
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/fr";

@Component({
  components: {
    DatePicker,
  },
})
/**
 * `v-model`-compatible datetime picker, thin wrapper around `vue2-datepicker`.
 * @remarks The template has a large commented-out alternative implementation using
 * `v-calendar`'s `vc-date-picker` — dead code, left as reference.
 */
export default class Datepicker extends Vue {
  private datetimeValue: any | null = null;

  @Prop() value!: any;

  mounted(): void {
    if (this.value) {
      this.datetimeValue = this.value;
    }
  }

  @Watch("datetimeValue")
  updateDatetimeValue(): void {
    this.$emit("update:datetime", this.datetimeValue);
    this.$emit("input", this.datetimeValue);
  }

  @Watch("value")
  updateValue(): void {
    this.datetimeValue = this.value;
  }
}
